








































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'TimeoutError',
})
export default class TimeoutError extends Vue {
  @Prop({ default: null })
  error!: Error | null;

  @Prop()
  onReload!: () => void;

  reload(): void {
    if (this.onReload) {
      this.onReload();
    }
  }
}
